import { StyleSheet } from "@react-pdf/renderer";

export const orderInvoiceStyles = StyleSheet.create({
  page: {
    fontFamily: "Helvetica",
    padding: 30,
    fontSize: 10,
    color: "#333",
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
  },
  logo: {
    width: 150,
  },
  titleContainer: {
    alignItems: "flex-end",
    gap: 5,
  },
  title: {
    fontSize: 18,
    fontWeight: "extrabold",
    color: "#008000",
  },
  subtitle: {
    fontSize: 12,
    color: "#666",
  },
  sectionTitle: {
    fontWeight: "bold",
    fontSize: 11,
    color: "#008000",
    marginBottom: 5,
  },
  companyDetails: {
    marginBottom: 10,
    color: "#666",
  },
  tableHeader: {
    flexDirection: "row",
    borderBottom: "1px solid #E4E4E4",
    paddingVertical: 10,
    backgroundColor: "#008000",
    color: "#fff",
    fontWeight: "bold",
    fontSize: 10,
    borderRadius: 3,
  },
  tableRow: {
    flexDirection: "row",
    paddingVertical: 10,
    borderBottom: "1px solid #E4E4E4",
  },
  tableCol: {
    width: "15%",
    textAlign: "center",
  },
  notesSection: {
    marginTop: 10,
    padding: 10,
    border: "1px solid #E4E4E4",
    borderRadius: 3,
    backgroundColor: "#F5F5F5",
    color: "#666",
  },
  notesTitle: {
    fontWeight: "bold",
    fontSize: 11,
    marginBottom: 5,
    color: "#008000",
  },
  notesText: {
    fontSize: 9,
    color: "#666",
  },
  orderSummary: {
    marginTop: 10,
    border: "1px solid #E4E4E4",
    padding: 10,
    borderRadius: 3,
    backgroundColor: "#F5F5F5",
    width: "40%",
    alignSelf: "flex-end",
  },
  summaryRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 2,
  },
  summaryText: {
    fontSize: 10,
  },
  grandTotal: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#008000",
  },
  footer: {
    marginTop: 20,
    borderTop: "1px solid #008000",
    paddingTop: 10,
    fontSize: 8,
    color: "#666",
    textAlign: "center",
  },
});
